import { useOidcUser } from '@axa-fr/react-oidc';
import { useMemo } from 'react';
import { BrokerUserDto } from './brokerUserDto';
import { brokerUserModelNormalizer } from './normalizers/brokerUserModelNormalizer';

export const useBrokerUserInfo = () => {
  const userInfo = useOidcUser();
  const userDto = userInfo.oidcUser as unknown as BrokerUserDto | null;
  const user = useMemo(
    () => (userDto ? brokerUserModelNormalizer(userDto) : null),
    [userDto]
  );

  return {
    user,
    loadingState: userInfo.oidcUserLoadingState,
  };
};
